import { CompanyLogo } from '@/components/other/company-logo';
import images from '@/public/assets/svg/auth-background.svg';
import {
  Box,
  Container,
  Flex,
  SimpleGrid,
  Text,
  Transition
} from '@mantine/core';
import { JSX, useEffect, useState } from 'react';
import { StackItem } from '../../other/stack-item';
import ErrorBoundary from './error-layout';
interface LayoutProps {
  children: React.ReactNode;
  hideLeft?: boolean;
  showLeftOnMobile?: boolean;
  sidelist?: {
    title?: string;
    list?: { title: React.ReactNode; icon: JSX.Element }[];
  };
}
export const AuthLayout: React.FC<LayoutProps> = ({
  children,
  showLeftOnMobile,
  hideLeft,
  sidelist,
}) => {
  const [animate, setAnimate] = useState(false);
  // const router = useRouter();
  useEffect(() => {
    setAnimate(true);
  }, []);
  return (
    <Box
      className="hide-scrollbar h-[100vh] overflow-y-auto overflow-x-hidden bg-cover bg-center bg-no-repeat"
      style={{
        backgroundImage: `url(${images})`,
      }}
    >
      <Flex className="absolute left-[-180px] top-0 z-50 w-full py-2">
        {/* <Button
          className="mt-4 bg-transparent"
          variant="white"
          onClick={() => router.push('/')}
        >
          <Flex className="gap-2 text-[20px]">
            <IconArrowLeft
              fill={'#0CAE5C'}
              className="m-auto text-center align-middle"
            />
            <Text className="hidden font-bold !text-vibrantgreen md:block">
              Home
            </Text>
          </Flex>
        </Button> */}
      </Flex>
      <Transition
        mounted={animate}
        transition="fade-left"
        duration={500}
        timingFunction="ease"
      >
        {(styles) => (
          <ErrorBoundary>
            <Container
              style={styles}
              size={hideLeft ? 'xs' : 'lg'}
              className="h-full w-full"
            >
              <SimpleGrid
                cols={{ base: 1, sm: hideLeft ? 1 : 2 }}
                spacing={'3rem'}
                className="h-full"
              >
                {!hideLeft && (
                  <Flex
                    c={'white'}
                    className={`${!showLeftOnMobile && 'hidden'} md:flex`}
                    justify={'center'}
                    direction={'column'}
                  >
                    <Box mt={57} mb={217}>
                      <CompanyLogo />
                    </Box>
                    <Box className='flex-1'>
                      <Text
                        mb={'2rem'}
                        className="text-[32px] font-medium leading-5 text-brandcore-P1"
                      >
                        {sidelist?.title ||
                          ' Experience our cutting-edge AI solutions firsthand.'}
                      </Text>
                      <StackItem sidelist={sidelist?.list} />
                    </Box>
                  </Flex>
                )}
                {children}
              </SimpleGrid>
            </Container>
          </ErrorBoundary>
        )}
      </Transition>
    </Box>
  );
};
